module.exports = __webpack_public_path__ + "static/media/SFProText-Bold.d6079ef0.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SFPro/TrueType/SFProText-Bold.ttf
// module id = 2554
// module chunks = 7